import { type TFunction } from 'i18next';

import { extractTeamsFromSubeventName } from '@cx-modules/utils';

/**
 * Translates a subevent name, mirroring the Subevent Header module's mechanism: when the
 * name is a "team v team" / "team at team" matchup, split it and translate each side
 * (preserving the separator); otherwise translate the whole string. The provided `t`
 * should be bound to the relevant namespaces (sport, label, bettype) by the caller, and
 * returns the original text when no translation exists.
 */
export const getTranslatedSubeventName = (subeventName: string, t: TFunction): string => {
  const teamsInfo = extractTeamsFromSubeventName(subeventName);
  if (!teamsInfo.success) return t(subeventName);

  return `${t(teamsInfo.first)}${teamsInfo.separator}${t(teamsInfo.second)}`.trim();
};
